import React from 'react';
// import PiggyBankAnimation from './PiggyBankAnimation';
import SplitText from './SplitText';
import ContactForm from './ContactForm';

const Hero: React.FC = () => {
 
  const scrollToForm = () => {
    // Scroll to the form title
    const formTitle = document.getElementById('contact-form');
    if (formTitle) {
      formTitle.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <>
      {/* Hero Section */}
      <section id="hero" className="relative min-h-screen overflow-hidden flex items-center justify-center bg-white">
        {/* Sfondo animato */}
        <svg
          className="absolute inset-0 w-full h-full z-0 opacity-60"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="line-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#0B63FF" />
              <stop offset="100%" stopColor="#43D8FF" />
            </linearGradient>
          </defs>

          <g fill="none" stroke="url(#line-gradient)" strokeWidth="0.7">
            <path className="wave wave1" d="M0 400 Q360 300 720 400 T1440 400" />
            <path className="wave wave2" d="M0 420 Q360 320 720 420 T1440 420" />
            <path className="wave wave3" d="M0 440 Q360 340 720 440 T1440 440" />
            <path className="wave wave4" d="M0 380 Q360 280 720 380 T1440 380" />
            <path className="wave wave5" d="M0 360 Q360 260 720 360 T1440 360" />
          </g>
        </svg>

        {/* Contenuto */}
        <div className="relative z-10 text-center max-w-4xl mx-auto px-4">
          <div className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-gray-900 text-balance">
            <SplitText
              text="Un nuovo modo di"
              className="inline"
              animation="fade-up"
              delay={200}
              duration={0.8}
              stagger={0.05}
            />
            {' '}
            <SplitText
              text="comprare"
              className="inline text-primary"
              animation="fade-up"
              delay={600}
              duration={0.8}
              stagger={0.05}
            />
            {' '}
            <SplitText
              text="materiali edili"
              className="inline"
              animation="fade-up"
              delay={800}
              duration={0.8}
              stagger={0.05}
            />
          </div>
          <SplitText
            text="Aggreghiamo le richieste di più clienti per ottentere condizioni di prezzo irraggiungibili al singolo."
            className="text-md sm:text-lg mb-8 text-gray-600 leading-relaxed max-w-3xl mx-auto text-balance"
            animation="fade-up"
            delay={1000}
            duration={0.8}
            stagger={0.03}
          />
          <button 
            onClick={scrollToForm}
            className={`px-8 py-2.5 rounded-full font-semibold text-lg transition-colors duration-300 bg-primary text-white hover:bg-primary/90'`}
          >
            Prova in anteprima
          </button>
        </div>

        <style>{`
          .wave {
            stroke-opacity: 0.3;
            animation: moveAndFade 12s linear infinite;
          }
          .wave1 { animation-duration: 14s; }
          .wave2 { animation-duration: 16s; animation-delay: -4s; }
          .wave3 { animation-duration: 18s; animation-delay: -2s; stroke-opacity: 0.25; }
          .wave4 { animation-duration: 20s; animation-delay: -6s; stroke-opacity: 0.35; }
          .wave5 { animation-duration: 22s; animation-delay: -8s; stroke-opacity: 0.2; }

          @keyframes moveAndFade {
            0% { 
              transform: translateX(0); 
              opacity: 0;
            }
            10% { 
              opacity: 1;
            }
            90% { 
              opacity: 1;
            }
            100% { 
              transform: translateX(-50%); 
              opacity: 0;
            }
        `}</style>
      </section>

      {/* Sezione 1: Non vendiamo, negoziamo per te. */}
      <section id="section-1" className="pb-28 pt-10 md:pb-48 md:pt-16 bg-light-bg">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              {/* Content */}
              <div className="order-1">
                  <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 text-balance">
                    <SplitText
                      text="Non vendiamo, negoziamo per te."
                      className="inline"
                      animation="fade-up"
                      delay={200}
                      duration={0.8}
                      stagger={0.05}
                    />
                  </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Unendo gli ordini di più clienti, Synergy tratta direttamente con i migliori produttori per ottenere prezzi da grande gruppo.
                </p>
              </div>

              {/* Image */}
              <div className="order-2">
                <div className="aspect-[4/3] rounded-3xl overflow-hidden">
                  <img 
                    src="/assets/images/negotiation-transparent.png" 
                    alt="Negotiation process illustration"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sezione 2: Il metodo Synergy */}
      <section id="section-2" className="py-28 md:py-48 bg-primary">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              {/* Content */}
              <div className="text-white order-1 lg:order-2">
                  <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-balance">
                    <SplitText
                      text="La nostra forza è l'unione"
                      className="inline"
                      animation="fade-up"
                      delay={200}
                      duration={0.8}
                      stagger={0.05}
                    />
                  </h2>
                <p className="text-lg text-blue-50 leading-relaxed">
                  Ti unisci a un ordine collettivo,
                  raggiungiamo insieme il volume necessario,
                  ottieni il prezzo scontato e la consegna garantita
                </p>
              </div>
              
              {/* Image placeholder */}
              <div className="order-2 lg:order-1">
                <div className="aspect-[4/3] overflow-hidden flex items-center justify-center">
                  {/* <div className="text-center"> */}
                    <img 
                      src="/assets/images/graph-image-transparent.png" 
                      alt=""
                      className="w-full h-full object-contain"
                    />
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sezione 3: Il tuo risparmio è il nostro interesse */}
      <section id="section-3" className="py-28 md:py-48 bg-light-bg">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              {/* Content */}
              <div className="order-1">
                  <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 text-balance">
                    <SplitText
                      text="Il tuo risparmio è il nostro interesse"
                      className="inline"
                      animation="fade-up"
                      delay={200}
                      duration={0.8}
                      stagger={0.05}
                    />
                  </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Più clienti partecipano, più il prezzo scende.
                  Synergy guadagna solo sul risparmio che otteniamo per te.
                </p>
              </div>

              {/* Image placeholder */}
               <div className="order-2">
                 <div className="aspect-[4/3] relative">
                  <img 
                    src="/assets/images/piggy-bank.png" 
                    alt=""
                    className="w-full h-full object-cover"
                  />
                   {/* <PiggyBankAnimation className="absolute top-1/2 left-1/2 w-[200%] h-[200%]  -translate-x-1/2 -translate-y-1/2" /> */}
                 </div>
               </div>
              
            </div>
          </div>
        </div>
      </section>
      <ContactForm />
    </>
  );
};

export default Hero;
